import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message, Popconfirm } from "antd";
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const MapToolManager = () => {
  const [mapTools, setMapTools] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingTool, setEditingTool] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/map_tool"; // Base URL para SGVMAP_MAP_TOOLController

  
  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }
  
  // Obtener la lista de herramientas
  const fetchMapTools = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, {
        headers: {
          Authorization: getAuthorization(),
        },
      }); // Asume un endpoint para listar todas las herramientas
      if (!response.ok) throw new Error("Error al obtener las herramientas");
      const data = await response.json();
      setMapTools(data);
    } catch (error) {
      message.error("Error al obtener la lista de herramientas");
      console.error(error);
    }
  };

  // Crear o actualizar una herramienta
  const handleSaveMapTool = async (values) => {
    const method = editingTool ? "PUT" : "POST";
    const url = editingTool
      ? `${baseURL}/update/${editingTool.idMapTool}`
      : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: { 
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar la herramienta");

      message.success(
        editingTool
          ? "Herramienta actualizada correctamente"
          : "Herramienta creada correctamente"
      );
      fetchMapTools();
      setIsModalOpen(false);
      setEditingTool(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar la herramienta");
      console.error(error);
    }
  };

  // Eliminar una herramienta
  const handleDeleteMapTool = async (idMapTool) => {
    try {
      const response = await fetch(`${baseURL}/delete/${idMapTool}`, {
        method: "DELETE",
        headers: {
          Authorization: getAuthorization(),
        },
      });
      if (!response.ok) throw new Error("Error al eliminar la herramienta");

      message.success("Herramienta eliminada correctamente");
      fetchMapTools();
    } catch (error) {
      message.error("Error al eliminar la herramienta");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (tool) => {
    setEditingTool(tool);
    form.setFieldsValue(tool);
    setIsModalOpen(true);
  };

  // Abrir modal para crear
  const handleCreate = () => {
    setEditingTool(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchMapTools();
  }, []);

  const columns = [
    {
      title: "ID Herramienta",
      dataIndex: "idMapTool",
      key: "idMapTool",
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar esta herramienta?"
            onConfirm={() => handleDeleteMapTool(record.idMapTool)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Herramientas de Mapa</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Herramienta
      </Button>
      <Table columns={columns} dataSource={mapTools} rowKey="idMapTool" />

      <Modal
        title={editingTool ? "Editar Herramienta" : "Crear Herramienta"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveMapTool}
          initialValues={{ name: "", config: "" }}
        >
          <Form.Item
            name="idMapTool"
            label="ID de la Herramienta"
            rules={[{ required: true, message: "Por favor, ingrese un ID de herramienta" }]}
          >
            <Input placeholder="ID de la Herramienta" />
          </Form.Item>

          <Form.Item
            name="name"
            label="Nombre"
            rules={[{ required: true, message: "Por favor, ingrese un nombre" }]}
          >
            <Input placeholder="Nombre de la Herramienta" />
          </Form.Item>
          <Form.Item
            name="config"
            label="Configuración"
            rules={[{ required: false }]}
          >
            <Input.TextArea placeholder="Configuración (opcional)" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MapToolManager;
